import { FC } from 'react';
import { Area } from './types';
import styles from './background.module.scss';

export const AreaBorders: FC<{
  area: Area;
  containerRect: DOMRect;
}> = ({ area, containerRect }) => {
  if (area.noBorder) return null;

  const x = area.x - containerRect.x;
  const y = area.y - containerRect.y;

  return (
    <div
      className={styles.border}
      style={{
        left: x - 12,
        top: y - 12,
        width: area.width + 24,
        height: area.height + 24,
      }}
    />
  );
};
